import { useMemo } from "react";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  CoreHotelsComponent,
} from "@b2bportal/core-types";
import {
  FilterAmenities,
  FilterCancellation,
  FilterRatingHorizontal,
  useFilterDialog,
} from "@tenant/hotels";
import {
  FilterDialogContainer,
  FilterDialogSection,
  FilterPrice,
} from "@tenant/ui";
import { HotelListSortOptions } from "../HotelListSort/HotelListSort";
import defaultStyles from "./FilterDialog.module.scss";

export const FilterDialog = () => {
  const styles = useFlightStyles(
    CoreHotelsComponent.FilterDialog,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreFlightsComponent.FilterDialog);

  const {
    text,
    context: {
      priceRange,
      amenities,
      cancellation,
      starRating,
      filterOptions,
      sortOption,
    },
    handlers: {
      updateValuesToMatchState,
      resetAllFilters,
      applyFilter,
      onPriceChange,
      onAmenitiesChange,
      onCancellationChange,
      onRatingChange,
      onSortChange,
    },
  } = useFilterDialog();

  const sortedAmenities = useMemo(
    () =>
      filterOptions.amenities
        .slice()
        .sort((a, b) => a.displayName.localeCompare(b.displayName)),
    [filterOptions.amenities]
  );

  return (
    <FilterDialogContainer
      onClickDialogTrigger={updateValuesToMatchState}
      onClickReset={resetAllFilters}
      onClickApply={applyFilter}
      className={block}
    >
      <div className={cn("root")}>
        <FilterDialogSection
          title={text.sortBy.title}
          content={
            <HotelListSortOptions
              selectedSort={sortOption}
              onChange={onSortChange}
            />
          }
        />
        <FilterDialogSection
          title={text.price.description}
          content={
            <FilterPrice
              isMinValueConfigurable
              minimumPrice={filterOptions.priceRange?.min}
              maximumPrice={filterOptions.priceRange?.max}
              initialValue={{
                minPrice: priceRange.min,
                maxPrice: priceRange.max,
              }}
              onFilterPriceChange={onPriceChange}
              label={""}
            />
          }
        />
        <FilterDialogSection
          title={text.cancellation.title}
          content={
            <FilterCancellation
              isFreeCancellationSelected={cancellation}
              onChange={onCancellationChange}
              label={text.cancellation.description}
            />
          }
        />
        <FilterDialogSection
          title={text.rating.title}
          content={
            <FilterRatingHorizontal
              selectedValues={starRating}
              onChange={onRatingChange}
            />
          }
        />
        <FilterDialogSection
          title={text.amenities.title}
          content={
            <FilterAmenities
              options={sortedAmenities}
              selectedValues={amenities}
              onChange={onAmenitiesChange}
            />
          }
        />
      </div>
    </FilterDialogContainer>
  );
};
